import React from 'react';
import useWindowSize from '../../../hooks/useWindowSize';
import partner01 from '../../../images/house-smart-partners/Carrier.svg';
import partner20 from '../../../images/house-smart-partners/Cemplank.svg';
import partner02 from '../../../images/house-smart-partners/CertainTeed.svg';
import partner03 from '../../../images/house-smart-partners/Congoleum.svg';
import partner04 from '../../../images/house-smart-partners/DuraCraft.svg';
import partner06 from '../../../images/house-smart-partners/Formica.svg';
import partner07 from '../../../images/house-smart-partners/Frigidaire.svg';
import partner08 from '../../../images/house-smart-partners/GeorgiaPacific.svg';
import partner09 from '../../../images/house-smart-partners/Hunter.svg';
import partner10 from '../../../images/house-smart-partners/HuntingtonBrass.svg';
import partner11 from '../../../images/house-smart-partners/JohnsManville.svg';
import partner14 from '../../../images/house-smart-partners/Kwikset.svg';
import partner12 from '../../../images/house-smart-partners/LP.svg';
import partner13 from '../../../images/house-smart-partners/LuxWindows.svg';
import partner15 from '../../../images/house-smart-partners/Moen.svg';
import partner16 from '../../../images/house-smart-partners/Norbord.svg';
import partner21 from '../../../images/house-smart-partners/Pfister.svg';
import partner17 from '../../../images/house-smart-partners/Shaw.svg';
import partner19 from '../../../images/house-smart-partners/WilsonArt.svg';
import partner05 from '../../../images/house-smart-partners/ecobee.svg';
import samsungLogo from '../../../images/house-smart-partners/Samsung.svg';

export const HouseSmartPartnerContent = () => {
  const [width, height] = useWindowSize();
  const isDesktop = width && width >= 1200;

  const partners = [
    {
      source: partner01,
      alt: 'Carrier',
    },
    {
      source: partner02,
      alt: 'Certain Teed',
    },
    {
      source: partner03,
      alt: 'Congoleum',
    },
    {
      source: partner04,
      alt: 'DuraCraft',
    },
    {
      source: partner05,
      alt: 'ecobee',
    },
    {
      source: isDesktop ? partner06 : partner07,
      alt: 'Formica',
    },
    {
      source: isDesktop ? partner07 : partner06,
      alt: 'Frigidaire',
    },
    {
      source: partner08,
      alt: 'Georgia Pacific',
    },
    {
      source: partner09,
      alt: 'Hunter',
    },
    {
      source: partner10,
      alt: 'Huntington Brass',
    },
    {
      source: partner11,
      alt: 'Johns Manville',
    },
    {
      source: partner12,
      alt: 'LP',
    },
    {
      source: partner13,
      alt: 'Lux Windows',
    },
    {
      source: partner14,
      alt: 'Kwikset',
    },
    {
      source: partner15,
      alt: 'Moen',
    },
    {
      source: partner17,
      alt: 'Shaw',
    },
    {
      source: partner19,
      alt: 'Wilson Art',
    },
    {
      source: partner20,
      alt: 'Cemplank',
    },
    {
      source: partner21,
      alt: 'Pfister',
    },
    {
      source: samsungLogo,
      alt: 'Samsung',
    },
    {
      source: partner16,
      alt: 'Norbord',
    },
  ];
  return (
    <>
      {partners && (
        <ul className="partner-list">
          {partners.map((item, i) => (
            <li key={item.alt ? item.alt : 'partner' + i}>
              <img src={item.source} alt={item.alt + ' logo'} />
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default HouseSmartPartnerContent;
